module.exports = __webpack_public_path__ + "static/img/1-1.b0cb18bd.png";